<template>
  <div class="homeMain">
    <div class="homeLeft">
      <div class="homeMap">
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle1"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle2"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle3"
        />
        <img
          src="../../../assets/supervise/borderRight.png"
          alt=""
          srcset=""
          class="trangleRight"
        />
        <!-- <el-button
                    type="primary"
                    icon="el-icon-refresh-right"
                    circle
                    @click="clearMap"
                    class="circleBtn"
                ></el-button> -->
        <div id="serveMap" class="serveMap"></div>
      </div>
      <div class="homeVersion">
        <img
          src="../../../assets/supervise/homeBottom.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">工单服务类型</p>
        <div class="homeServe">
          <div class="serveBox">
            <div class="serveItem">
              <img
                src="../../../assets/supervise/homeCadre.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">老干部</p>
              <p class="nums">{{ oldInfo.laogan }}</p>
            </div>
            <div class="serveItem serveItem1">
              <img
                src="../../../assets/supervise/assistance.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">民政购买</p>
              <p class="nums">{{ oldInfo.mingzheng }}</p>
            </div>
            <div class="serveItem">
              <img
                src="../../../assets/supervise/disabledPersons.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">残联服务</p>
              <p class="nums">{{ oldInfo.canlian }}</p>
            </div>
          </div>
          <div class="serveBox">
            <div class="serveItem">
              <img
                src="../../../assets/supervise/civilized.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">文明办</p>
              <p class="nums">{{ oldInfo.wenmingban }}</p>
            </div>
            <div class="serveItem serveItem1">
              <img
                src="../../../assets/supervise/businessServe.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">商业服务</p>
              <p class="nums">{{ oldInfo.shangye }}</p>
            </div>
            <div class="serveItem">
              <img
                src="../../../assets/supervise/return.png"
                class="companyImg"
                alt=""
                srcset=""
              />
              <p class="name">信息回访</p>
              <p class="nums">{{ oldInfo.xinxi }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeCenter">
      <div class="serveObj">
        <img
          src="../../../assets/supervise/serveObj.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle serveTitle1">服务对象类型</p>
        <div class="serveObjTop">
          <div class="serveBoxes">
            <div
              class="serveItem"
              @click="getServeTypes(item.id, item.count, index)"
              v-for="(item, index) in serveInfo"
              :key="index"
            >
              <img :src="item.img" alt="" srcset="" class="mapPoint" />
              <div class="serveFlex">
                <p class="name">{{ item.name }}</p>
                <p class="nums lgbColor">
                  {{ item.count }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demographic">
        <img
          src="../../../assets/supervise/demographicIcon.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">人口分析</p>
        <div class="demogTab">
          <span :class="grapIndex == 0 ? 'grapCur' : ''" @click="grapTap(0)"
            >年龄分布</span
          >
          <span :class="grapIndex == 1 ? 'grapCur' : ''" @click="grapTap(1)"
            >居住情况</span
          >
          <span :class="grapIndex == 2 ? 'grapCur' : ''" @click="grapTap(2)"
            >经济来源</span
          >
          <span :class="grapIndex == 3 ? 'grapCur' : ''" @click="grapTap(3)"
            >自理类型</span
          >
        </div>
        <div class="demogDes">
          <div id="ageArea" class="demogItem" v-if="grapIndex == 0"></div>
          <div id="homeArea" class="demogItem" v-if="grapIndex == 1"></div>
          <div id="moneyArea" class="demogItem" v-if="grapIndex == 2"></div>
          <div id="oldArea" class="demogItem" v-if="grapIndex == 3"></div>
        </div>
        <p class="peopleName">人口区域分布</p>
        <div class="peopleArea" id="peopleArea"></div>
      </div>
    </div>
    <div class="homeRight">
      <div class="companyServe">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="compayTop">
          <div class="companyTab">
            <span
              :class="companyIndex == 0 ? 'curIndex' : ''"
              @click="serverTap(0)"
              >异常工单</span
            >
            <span
              :class="companyIndex == 1 ? 'curIndex' : ''"
              @click="serverTap(1)"
              >服务评价</span
            >
            <span
              :class="companyIndex == 2 ? 'curIndex' : ''"
              @click="serverTap(2)"
              >客服系统</span
            >
          </div>
        </div>
        <div style="color: #fff; text-align: center">
          <span v-if="companyIndex == 0">服务工单异常率 (8.5%)</span>
          <span v-if="companyIndex == 1">服务满意度 (98.4%)</span>
        </div>
        <div v-if="companyIndex == 0">
          <div class="companyHead">
            <span class="item2">工单流水号</span>
            <span class="item">姓名</span>
            <span class="item">类型</span>
            <span class="item">状态</span>
          </div>
          <div
            class="compayDes"
            @click.stop="clickProps($event)"
            v-if="companyIndex == 0"
          >
            <vue-seamless-scroll
              :style="{
                height: 270 + 'px',
              }"
              :data="tableData"
              :class-option="classOption"
              class="warp-content"
            >
              <div
                class="desItem"
                v-for="(item, index) in tableData"
                :key="index"
              >
                <p class="item2" :id="index" :data-obj="JSON.stringify(item)">
                  {{ item.orderNum }}
                </p>
                <p class="item" :id="index" :data-obj="JSON.stringify(item)">
                  {{ item.customerName }}
                </p>
                <p class="item" :id="index" :data-obj="JSON.stringify(item)">
                  <span
                    v-if="item.exceptionStatus == 1"
                    :id="index"
                    :data-obj="JSON.stringify(item)"
                    >位置异常</span
                  >
                  <span
                    v-if="item.exceptionStatus == 2"
                    :id="index"
                    :data-obj="JSON.stringify(item)"
                    >时间异常</span
                  >
                </p>
                <p class="item" :id="index" :data-obj="JSON.stringify(item)">
                  <span
                    v-if="
                      item.processStatus == '' || item.processStatus == null
                    "
                    :id="index"
                    :data-obj="JSON.stringify(item)"
                    >未处置</span
                  >
                  <span
                    v-if="
                      item.processStatus == '1' || item.processStatus == '2'
                    "
                    :id="index"
                    :data-obj="JSON.stringify(item)"
                    >已处置</span
                  >
                </p>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>

        <div id="concatCahrt" class="charmap" v-if="companyIndex == 1"></div>

        <div id="startCahrt" class="charmap" v-if="companyIndex == 2"></div>
      </div>
      <div class="serveStation">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">机构点</p>
        <div id="serveStaion"></div>
      </div>
    </div>
    <!-- 弹窗 start -->
    <div class="maskModel" v-if="isMasked">
      <div class="yearMoney">
        <p class="name">基本信息</p>
        <img
          src="../../../assets/supervise/normalCanle.png"
          alt=""
          srcset=""
          @click="closeInfo"
          class="maskClose"
        />
      </div>
      <div class="personFlex">
        <div class="right-1">
          <div>
            <div class="right-title-1 right-title-2">
              <div>姓名</div>
              <div>{{ maskInfo.customerName }}</div>
            </div>
            <div class="right-title-1">
              <div>性别</div>
              <div style="display: flex; justify-content: center">
                <el-select
                  disabled
                  v-model="maskInfo.gender"
                  placeholder="性别"
                  size="medium"
                  style="width: 100%"
                >
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </div>
            </div>
            <div class="right-title-1">
              <div>手机号码</div>
              <div>
                {{ maskInfo.phone }}
              </div>
            </div>
            <div class="right-title-1">
              <div>家庭电话</div>
              <div>
                {{ maskInfo.familyCall }}
              </div>
            </div>
            <div class="right-title-1">
              <div>民族</div>
              <div>
                {{ maskInfo.nation }}
              </div>
            </div>
            <div class="right-title-1">
              <div>用户类型</div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="maskInfo.customerTypeStr"
                  placement="bottom-start"
                >
                  <div>{{ maskInfo.customerTypeStr }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>老人所属类别</div>
              <div>
                <el-select
                  v-model="maskInfo.elderlyBelongCategory"
                  placeholder="暂无数据"
                  size="medium"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in oldtypeLits"
                    :key="index"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  ></el-option>
                  <!-- <el-option
                                        label="特困老人"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="低保老人"
                                        :value="2"
                                    ></el-option>
                                    <el-option
                                        label="建档立卡贫困老人"
                                        :value="3"
                                    ></el-option>
                                    <el-option
                                        label="优抚对象"
                                        :value="4"
                                    ></el-option>
                                    <el-option
                                        label="失独老人"
                                        :value="5"
                                    ></el-option>
                                    <el-option
                                        label="残疾老人"
                                        :value="6"
                                    ></el-option>
                                    <el-option
                                        label="空巢老人"
                                        :value="7"
                                    ></el-option>
                                    <el-option
                                        label="农村留守老人"
                                        :value="8"
                                    ></el-option>
                                    <el-option
                                        label="计划生育特殊家庭成员"
                                        :value="9"
                                    ></el-option>
                                    <el-option
                                        label="其他"
                                        :value="0"
                                    ></el-option> -->
                </el-select>
              </div>
            </div>
          </div>
          <div>
            <div class="right-title-1 right-title-2 right-title-3">
              <div>身份证号</div>
              <div>
                <el-input
                  v-model="maskInfo.idCard"
                  size="medium"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>出生日期</div>
              <div>
                <el-input
                  disabled
                  v-model="maskInfo.birthday"
                  size="medium"
                  placeholder="根据身份证号获取"
                ></el-input>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>年龄</div>
              <div>
                <el-input
                  disabled
                  v-model="maskInfo.age"
                  size="medium"
                  placeholder="根据身份证号获取"
                ></el-input>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>婚姻状态</div>
              <div>
                <el-select
                  style="width: 100%"
                  v-model="maskInfo.marriageStatus"
                  placeholder="暂无数据"
                  size="medium"
                  disabled
                >
                  <el-option
                    v-for="item in marriageList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>生活区域</div>
              <div>
                <el-select
                  style="width: 100%"
                  v-model="maskInfo.lifeArea"
                  placeholder="暂无数据"
                  size="medium"
                  disabled
                >
                  <el-option label="城市" :value="1"></el-option>
                  <el-option label="农村" :value="2"></el-option>
                </el-select>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>区域名称</div>
              <div>
                <el-select
                  v-model="maskInfo.area"
                  placeholder="暂无数据"
                  size="mini"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="item in quyuList"
                    :key="item.orgId"
                    :label="item.label"
                    :value="item.orgId"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="right-title-1 right-title-3">
              <div>所属机构</div>
              <div>
                <el-select
                  v-model="maskInfo.serviceStation"
                  placeholder="暂无数据"
                  size="mini"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="item in serviceStationList"
                    :key="item.selectTreeId"
                    :label="item.statName"
                    :value="item.selectTreeId"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="border-bottom: 1px solid #fff">
            <div class="right-2">
              <div>
                <div v-if="codeState == false">
                  <img
                    v-if="maskInfo.photo !== null"
                    :src="maskInfo.photo"
                    class="avatar"
                  />
                  <img
                    v-else
                    src="../../../assets/supervise/photo.png"
                    class="avatar"
                  />
                </div>
                <vue-qr
                  v-if="codeState == true"
                  :text="String(maskInfo.id)"
                  :size="178"
                ></vue-qr>
                <div class="shangchuang2">
                  <span class="item" @click="getPicture">老人照片</span>
                  <div class="item item1" v-if="maskInfo.id" @click="getCode">
                    老人二维码
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-1">
          <div>
            <div class="right-title-5 right-title-3">
              <div>居住情况</div>
              <div class="right-title-4">
                <div>
                  <el-radio-group v-model="maskInfo.liveCondition" disabled>
                    <el-radio label="4">独自居住</el-radio>
                    <el-radio label="5">与配偶居住 </el-radio>
                    <el-radio label="3">与子女居住 </el-radio>
                    <el-radio label="6">其他</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="right-title-5 right-title-3">
              <div>经济来源</div>
              <div class="right-title-4">
                <div>
                  <el-checkbox-group v-model="economicSourceId" disabled>
                    <el-checkbox label="0">养老金</el-checkbox>
                    <el-checkbox label="1">子女供养 </el-checkbox>
                    <el-checkbox label="2">救济优抚 </el-checkbox>
                    <el-checkbox label="3">兼职</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <div class="right-title-6 right-title-3">
              <div>个人喜好</div>
              <div class="right-title-4">
                <div>
                  <el-checkbox-group v-model="hobbyId" disabled>
                    <el-checkbox label="棋牌">棋牌</el-checkbox>
                    <el-checkbox label="舞蹈">舞蹈</el-checkbox>
                    <el-checkbox label="诗词">诗词</el-checkbox>
                    <el-checkbox label="戏曲">戏曲</el-checkbox>
                    <el-checkbox label="钓鱼">钓鱼</el-checkbox>
                    <el-checkbox label="书画">书画</el-checkbox>
                    <el-checkbox label="收藏">收藏</el-checkbox>
                    <el-checkbox label="摄影">摄影</el-checkbox>
                    <el-checkbox label="旅游">旅游</el-checkbox>
                    <el-checkbox label="唱歌">唱歌</el-checkbox>
                    <el-checkbox label="手工">手工</el-checkbox>
                    <el-checkbox label="健康养生">健康养生 </el-checkbox>
                    <el-checkbox label="体育健身">体育健身 </el-checkbox>
                    <el-checkbox label="其他">其他</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <div class="right-title-7 right-title-3">
              <div>联系地址</div>
              <div>
                <el-input
                  size="mini"
                  readonly
                  v-model="maskInfo.address"
                  disabled
                ></el-input>
              </div>
            </div>
            <div class="right-title-8 right-title-3">
              <div>备注</div>
              <div>
                <el-input
                  v-model="maskInfo.remark"
                  size="mini"
                  :rows="3"
                  type="textarea"
                  disabled
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import vueQr from "vue-qr"
import request from "@/utils/request.js"
import Highcharts from "highcharts/highstock"
import Highcharts3D from "highcharts/highcharts-3d"
import exportVue from "@/utils/exportVue"
Highcharts3D(Highcharts)
export default {
  data() {
    return {
      oldtypeLits: [],
      marriageList: [
        {
          value: 1,
          label: "未婚",
        },
        {
          value: 2,
          label: "已婚",
        },
        {
          value: 3,
          label: "离婚",
        },
        {
          value: 4,
          label: "丧偶",
        },
        {
          value: 5,
          label: "初婚",
        },
        {
          value: 6,
          label: "再婚",
        },
        {
          value: 7,
          label: "复婚",
        },
      ],
      dataIds: [],
      codeState: false,
      orderList: [],
      normalInfo: {},
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: [], //地图标记点
      markers: [],
      recMap: null,
      recIsMap: true,
      companyIndex: 0,
      tableData: [],
      grapIndex: 0,
      // serveInfo: {
      //     canlian: 0,
      //     // junren: 0,
      //     laogan: 0,
      //     shangye: 0,
      //     wenmingban: 0,
      //     zhenfuyuanzhu: 0,
      // },
      serveInfo: [],
      oldInfo: {
        canlian: 0,
        laogan: 0,
        mingzheng: 0,
        shangye: 0,
        wenmingban: 0,
        xinxi: 0,
      },
      dataInfo: {},
      infoWindow: null,
      isMasked: false,
      maskInfo: {
        customerType: [],
      },
      servePj: [],
      orderPage: { pageNo: 1, pageSize: 8, total: 0 },
      serviceStationList: [],
      quyuList: [],
      economicSosurceId: [],
      hobbyId: [],
      canlianState: false,
      junrenState: false,
      laoganState: false,
      shangyeState: false,
      wenmingbanState: false,
      zhengfuyuanzhu: false,
      canlianPage: { pageNo: 1, pageSize: 1000, total: 0 },
      junrenPage: { pageNo: 1, pageSize: 1000, total: 0 },
      laoganPage: { pageNo: 1, pageSize: 1000, total: 0 },
      shangyePage: { pageNo: 1, pageSize: 1000, total: 0 },
      wenmingbanPage: { pageNo: 1, pageSize: 1000, total: 0 },
      zhengfuyuanzhuPage: { pageNo: 1, pageSize: 1000, total: 0 },
      serverConcatTap: [],
      dataIds: [],
    }
  },
  created() {
    this.canlianState = true
    this.junrenState = true
    this.laoganState = true
    this.shangyeState = true
    this.wenmingbanState = true
    this.zhengfuyuanzhu = true
    exportVue.$on("dataIds", (data) => {
      if (data) {
        this.dataIds = data
      }
    })
  },
  watch: {
    dataIds(val) {
      if (val) {
        this.oldListshow(val)
        this.getWorks(val)
        this.getServe(val)
        this.getAge(val)
        this.getHome(val)
        this.getSource(val)
        this.getCare(val)
        this.peopleArea(val)
        this.getOrder(val)
        this.getSation(val)
        this.getAbnormal(val)
        this.serverTap(1)
      }
    },
  },
  async mounted() {
    this.getOrg()
    // 机构点
    this.getSation()
    // 异常工单
    this.getAbnormal()
    // 年龄分布
    this.getAge()
    // 人口区域分布
    this.peopleArea()
    // await this.loadmap().then(() => {
    //     // 工单服务
    //     this.getWorks()
    //     // 服务对象
    //    this.getServe()
    // })
    //await this.getDistrictss("341100")
  },
  components: {
    vueQr,
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  _methods: {
    //所有老人打点
    oldListshow(dataIds) {
      this.myMap.remove(this.marker)
      this.myMap.remove(this.markers)
      this.marker = []
      this.markers = []
      request({
        url: "/jjyl/admin/center/customer/info/findListLoc",
        method: "POST",
        data: { dataIds: dataIds },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            res.content.list.forEach((item) => {
              item.icons = require("../../../assets/supervise/pold.png")
              item.latitude = item.latitude
              item.longitude = item.longitude
            })
            this.getPoints(res.content.list)
          }
          this.$forceUpdate()
        }
      })
    },

    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          //console.log(res)
          if (res.code === 200) {
            const arr = []
            this.loopTree(res.content, arr)
            this.quyuList = arr.filter((item) => {
              return item.orgId == this.maskInfo.area
            })
            //console.log(this.quyuList, "组织")
          }
        }
      )
    },
    // 树转同级
    loopTree(data, arr) {
      data.forEach((item) => {
        arr.push(item)
        if (Array.isArray(item.children)) {
          this.loopTree(item.children, arr)
        }
      })
    },
    getTreeChecked() {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id,
                statName: item.statName,
              }
            })
          }
        })
    },
    // 二维码
    getCode() {
      this.codeState = true
    },
    getPicture() {
      this.codeState = false
    },
    // 服务tap
    serverTap(num) {
      this.companyIndex = num
      if (this.companyIndex == 1) {
        this.$nextTick(() => {
          this.$http
            .request({
              url: "/jjyl/servicePgd/info/findServiceEvaluation",
              method: "POST",
              data: {
                dataIds: this.dataIds,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (res.content == null || res.content == "null") {
                  return
                }
                this.servePj = [
                  res.content.wpj,
                  res.content.One,
                  res.content.Two,
                  res.content.Three,
                  res.content.Four,
                  res.content.Five,
                ]

                this.getServes(this.servePj)
              }
            })
        })
      } else if (this.companyIndex == 2) {
        this.$nextTick(() => {
          this.$http
            .request({
              url: "/jjyl/admin/serviceStaffCustomerCenter/info/findPosition",
              method: "POST",
              data: {
                dataIds: this.dataIds,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                let a = res.content
                if (!a[1]) {
                  a[1] = 0
                }
                if (!a[2]) {
                  a[2] = 0
                }
                if (!a[3]) {
                  a[3] = 0
                }
                this.serverConcatTap = [
                  { value: a[1], name: "站长" },
                  { value: a[2], name: "副站长" },
                  { value: a[3], name: "普通员工" },
                ]
                //console.log(this.serverConcatTap)
                this.getConcat(this.serverConcatTap)
              }
            })
        })
      }
    },
    // 服务评价
    getServes(serveData) {
      let mayChart1 = this.$echarts.init(document.getElementById("concatCahrt"))
      mayChart1.clear()
      let option1
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#2889fe"],
        grid: {
          left: "10%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          type: "category",
          data: [
            "未评价",
            "没有服务",
            "不满意",
            "服务一般",
            "基本满意",
            "非常满意",
          ],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff", //这里用参数代替了
            },
          },
        },
        series: [
          {
            name: "满意度",
            type: "bar",
            data: serveData,
          },
        ],
      }
      option1 && mayChart1.setOption(option1)
    },
    // 客服系统
    getConcat() {
      let mayChart2 = this.$echarts.init(document.getElementById("startCahrt"))
      mayChart2.clear()
      let option2
      option2 = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "right",
          top: "center",
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
        },
        series: [
          {
            name: "职位",
            type: "pie",
            radius: "50%",
            // data: [
            //     { value: 1048, name: "普通员工" },
            //     { value: 735, name: "副站长" },
            //     { value: 580, name: "站长" },
            // ],
            data: this.serverConcatTap,
          },
        ],
      }
      option2 && mayChart2.setOption(option2)
    },
    //渲染区域信息
    getDistrictss(city, chooseCity = "") {
      return new Promise((resolve, rejcet) => {
        let self = this
        //根据市获取下一级行政区
        let opts = {
          subdistrict: 1,
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let tempArr = []
        let district = new AMap.DistrictSearch(opts) //注意：需要使用插件同步下发功能才能这样直接使用
        district.search(city, function (status, result) {
          if (status == "complete") {
            result.districtList[0].districtList.forEach((item) => {
              tempArr.push(item.name)
            })
            //console.log(tempArr, chooseCity, "信息")
            if (!chooseCity) {
              tempArr.forEach((item, index) => {
                self.renderPolygon(district, item, index)
              })
            } else {
              tempArr.forEach((item, index) => {
                if (item == chooseCity) {
                  self.renderPolygon(district, item, index)
                } else {
                  //console.log("没有当前区域")
                }
              })
            }
            resolve()
          }
        })
      })
    },
    //渲染行政区边界
    renderPolygon(district, item, index) {
      let self = this
      let color = [
        "#f73131",
        "#fff816",
        "#ff16d8",
        "#709438",
        "#25A5F7",
        "#315EFB",
        "#771CAA",
        "#045206",
        "#6ec55e",
        "#e8ac00",
        "#f77325",
        "#1d15a0",
        "#39fda2",
      ]
      self.myMap.remove(self.polygons)
      self.polygons.length = []
      district.search(item, function (status, result) {
        let bounds = result.districtList[0].boundaries
        self.polygon = null
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.4,
              fillColor: color[index],
              strokeColor: color[index],
              strokeStyle: item,
            })
            self.polygons.push(self.polygon)
          }
        }
        self.myMap.add(self.polygons)
        self.myMap.setFitView(self.polygons) //视口自适应
      })
    },
    // 服务工单分页
    handleCurrentChange(val) {
      this.orderPage.pageNo = val
      this.getOrder(this.dataIds)
    },
    // 服务工单
    getOrder(dataIds) {
      const self = this
      // orderList
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: {
          customer: self.maskInfo.id,
          pageNo: self.orderPage.pageNo,
          pageSize: self.orderPage.pageSize,
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            self.orderList = res.content.list
            self.orderPage.total = res.content.count
          } else {
            self.orderList = []
            self.orderPage.total = 0
          }
        }
        this.$forceUpdate()
      })
    },
    // 关闭弹窗
    closeInfo() {
      this.isMasked = false
      this.maskInfo = {}
    },
    // 服务对象类型切换
    getServeTypes(type, num, index) {
      const self = this
      self.myMap.remove(self.marker)
      self.myMap.remove(self.markers)
      self.marker = []
      self.markers = []
      self.canlianState = false
      self.junrenState = false
      self.laoganState = false
      self.shangyeState = false
      self.wenmingbanState = false
      self.zhengfuyuanzhu = false
      if (num > 0) {
        // setTimeout(async () => {
        //     await self.$nextTick(() => {
        //         if (type == 3) {
        //             self.canlianState = true
        //             self.canlianAddress(3, this.dataIds)
        //         } else if (type == 13) {
        //             self.junrenState = true
        //             self.junrenAddress(13, this.dataIds)
        //         } else if (type == 4) {
        //             self.laoganState = true
        //             self.laoganAddress(4, this.dataIds)
        //         } else if (type == 7) {
        //             self.shangyeState = true
        //             self.shangyeAddress(7, this.dataIds)
        //         } else if (type == 10) {
        //             self.wenmingbanState = true
        //             self.wenmingbanAddress(10, this.dataIds)
        //         } else if (type == 6) {
        //             self.zhengfuyuanzhu = true
        //             self.zhengfuyuanzhuAddress(6, this.dataIds)
        //         }
        //     })
        // })
        self.getOld(type, this.dataIds, index)
      } else {
        this.$message.warning("暂无数据")
      }
    },
    getOld(type, dataIds, index) {
      let self = this
      if (dataIds.length == 0) {
        var dataId = null
      } else {
        var dataId = dataIds
      }
      request({
        url: "/jjyl/admin/center/customer/info/findCusTypeLoc",
        method: "POST",
        data: {
          customerType: type,
          pageNo: self.canlianPage.pageNo,
          pageSize: self.canlianPage.pageSize,
          dataIds: dataId,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          res.content.forEach((item) => {
            // item.icons = require("../../../assets/supervise/marker2.png")
            if (index == 0) {
              item.icons = require("../../../assets/supervise/lgbMap.png")
            } else if (index == 1) {
              item.icons = require("../../../assets/supervise/zfyzMap.png")
            } else if (index == 2) {
              item.icons = require("../../../assets/supervise/clMap.png")
            } else if (index == 3) {
              item.icons = require("../../../assets/supervise/wmbMap.png")
            } else if (index == 4) {
              item.icons = require("../../../assets/supervise/syMap.png")
            }
          })

          this.getPoints(res.content)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    clearMap() {
      const self = this
      self.myMap.remove(self.marker)
      self.myMap.remove(self.markers)
      self.marker = []
      self.markers = []
      self.getServe()
    },
    // 打点
    potintMap(longitude, latitude) {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        //console.log(err)
      }
      this.infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30),
        // isCustom: true,
      })
      self.marker = new AMap.Marker({
        icon: new AMap.Icon({
          image: require("../../../assets/supervise/adIcon2.png"),
          size: new AMap.Size(52, 52),
          imageSize: new AMap.Size(30, 30),
        }),
        position: [self.dataInfo.longitude, self.dataInfo.latitude],
      })
      let coent = this.dataInfo
      let exceptionStatusName = ""
      if (coent.exceptionStatus == 1) {
        exceptionStatusName = "位置异常"
      } else if (coent.exceptionStatus == 2) {
        exceptionStatusName = "时间异常"
      } else if (coent.exceptionStatus == 3) {
        exceptionStatusName = "位置异常、时间异常"
      }
      coent.processStatusName =
        coent.processStatus == "" || coent.processStatus == null
          ? "未处置"
          : "已处置"
      coent.exceptionStatusName = exceptionStatusName
      self.marker.content = `<div class="mapModel">
              <p class="mapTitle"><span class="name">异常工单详情</span></p>
              <ul class="mapUl">
                <li class="mapLi"><span class="name">客户姓名：</span><p class="content">${coent.customerName}</p></li>
                <li class="mapLi"><span class="name">联系电话：</span><p class="content">${coent.customerphone}</p></li>
                <li class="mapLi"><span class="name">联系地址：</span><p class="content">${coent.address}</p></li>
                <li class="mapLi"><span class="name">异常类型：</span><p class="content">${coent.exceptionStatusName}</p></li>
                <li class="mapLi"><span class="name">套餐类型：</span><p class="content">${coent.ensureName}</p></li>
                <li class="mapLi"><span class="name">套餐服务时长：</span><p class="content">${coent.period}分钟</p></li>
                 <li class="mapLi"><span class="name">服务项目：</span><p class="content">${coent.servetypename}</p></li>
                <li class="mapLi"><span class="name">服务种类：</span><p class="content">${coent.serviceTypeName}</p></li>
                 <li class="mapLi"><span class="name">状态：</span><p class="content">${coent.processStatusName}</p></li>
              </ul>
            </div>`
      self.marker.on("click", self.markerClick)
      self.marker.emit("click", { target: self.marker })
      // self.infoWindow.open(self.myMap, [
      //     self.dataInfo.longitude,
      //     self.dataInfo.latitude,
      // ])
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    markerClick(e) {
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.myMap, e.target.getPosition())
    },

    // 点击事件
    clickProps(e) {
      // //console.log(e.target)
      let index = e.target.id
      let item = JSON.parse(e.target.dataset.obj)
      this.dataInfo = item
      this.potintMap()
      // //console.log(index, item, "数据")
    },
    // 打点
    getPoints(data) {
      const self = this
      data.forEach((item) => {
        // //console.log(item, "数据")
        if (item.longitudeElderly == null || item.longitudeElderly == "") {
          // //console.log(item.id, item.longitudeElderly)
          // //console.log(item.longitude, item.latitude)
          if (item.longitude && item.latitude) {
            let marker = new AMap.Marker({
              position: [item.longitude, item.latitude],
              icon: new AMap.Icon({
                image: item.icons,
                size: new AMap.Size(50, 50),
                imageSize: new AMap.Size(20, 20),
              }),
              extData: {
                id: item.id,
              },
            })
            self.markers.push(marker)
            marker.on("click", self.maskModel)
          }
        } else {
          //console.log(item.id, item.longitudeElderly)
          if (item.longitudeElderly && item.latitudeElderly) {
            let marker = new AMap.Marker({
              position: [item.longitudeElderly, item.latitudeElderly],
              icon: new AMap.Icon({
                image: item.icons,
                size: new AMap.Size(50, 50),
                imageSize: new AMap.Size(20, 20),
              }),
              extData: {
                id: item.id,
              },
            })
            //console.log(marker)
            self.markers.push(marker)
            marker.on("click", self.maskModel)
          }
        }
      })
      this.myMap.add(self.markers)
    },
    getOldInfo(id) {
      const self = this
      request({
        url: "/jjyl/admin/center/customer/info/get",
        method: "POST",
        data: {
          id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            self.isMasked = true
            //console.log(this.quyuList, "2222")
            this.gettypeList()
            // res.content.customerType.split(",").forEach(i => {
            //     //console.log(typeof Number(i))
            //     self.maskInfo.customerType = (Number(i))
            // })
            // //console.log(self.maskInfo.customerType);
            self.maskInfo = {
              customerTypeStr: res.content.customerTypeStr,
              id: res.content.id,
              customerName: res.content.customerName,
              gender: res.content.gender,
              age: res.content.age,
              phone: res.content.phone,
              address: res.content.address,
              familyCall: res.content.familyCall,
              nation: res.content.nation,
              customerType: res.content.customerType.split(","),
              elderlyBelongCategory: Number(res.content.elderlyBelongCategory),
              idCard: res.content.idCard,
              birthday: res.content.birthday,
              marriageStatus: res.content.marriageStatus,
              lifeArea: res.content.lifeArea,
              economicSource:
                res.content.economicSource == null
                  ? []
                  : res.content.economicSource.split(","),
              area: String(res.content.area),
              serviceStation: res.content.serviceStation,
              hobby:
                res.content.hobby == null ? [] : res.content.hobby.split(","),
              photo: res.content.photo,
            }
            self.economicSourceId = self.maskInfo.economicSource
            self.hobbyId = self.maskInfo.hobby
            this.getTree()
            if (self.maskInfo.customerTypeStr.indexOf("null") != -1) {
              //有出现
              self.maskInfo.customerTypeStr = ""
            }
          } else {
            self.maskInfo = {}
          }
        }
      })
    },
    gettypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        // dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          //console.log(res, "0000000000")
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
            }
          }
        })
    },
    // 设置弹窗
    maskModel(e) {
      let item = Object.assign({}, e.target.w.extData)
      this.getTreeChecked()

      // this.isMasked = true
      // this.maskInfo = item
      this.getOldInfo(item.id)
      // this.economicSourceId = item.economicSource
      // this.hobbyId = item.hobby
      // this.orderPage.pageNo = 1
      // this.getOrder()
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1,
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "",
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          //console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        //console.log(err)
      })
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        //console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      if (val != null || val != "" || val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: val,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                resolve(res.content)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {
          //console.log(err)
        })
      }
    },

    // request
    getOrg() {
      const self = this
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then(async (res) => {
          if (res.code == 200) {
            //console.log(res, "getorg")
            this.normalInfo = res.content

            if (res.content.latitude && res.content.longitude) {
              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(res.content.longitude, res.content.latitude)
                  //所有老人打点
                  this.oldListshow()
                  // 工单服务
                  self.getWorks()
                  // 服务对象
                  self.getServe()
                  // self.potintMap(res.content.longitude,
                  //   res.content.latitude)
                })
              }, 300)
            } else {
              let provinceList = [],
                cityList = [],
                areaList = [],
                streetList = [],
                communityList = [],
                longitude = "",
                latitude = ""
              let province = await this.getDistricts()
              provinceList = province.districtList
              if (this.normalInfo.provinceId) {
                let city = await this.getDistricts(this.normalInfo.provinceId)
                cityList = city.districtList
              }
              if (this.normalInfo.cityId) {
                let area = await this.getDistricts(this.normalInfo.cityId)
                areaList = area.districtList
              }
              if (this.normalInfo.areaId) {
                let street = await this.getStreetList(this.normalInfo.areaId)
                streetList = street
              }
              if (this.normalInfo.streetId) {
                let community = await this.getCommityList(
                  Number(this.normalInfo.streetId)
                )
                communityList = community
              }
              if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
              ) {
                provinceList.forEach((item) => {
                  if (item.adcode == this.normalInfo.provinceId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                    //console.log()
                  }
                })
              } else if (this.normalInfo.orgLevel == 2) {
                cityList.forEach((item) => {
                  if (item.adcode == this.normalInfo.cityId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (this.normalInfo.orgLevel == 3) {
                areaList.forEach((item) => {
                  if (item.adcode == this.normalInfo.areaId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
              ) {
                streetList.forEach((item, index) => {
                  if (item.adcode + index == this.normalInfo.streetId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              }
              //console.log(longitude, latitude, "www")
              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(longitude, latitude)
                  // 工单服务
                  self.getWorks()
                  // 服务对象
                  self.getServe()
                  // self.potintMap(longitude, latitude)
                })
              }, 30)
            }
            var polygonArr = []
            if (res.content.pointPosition) {
              res.content.pointPosition.split(",").forEach((e) => {
                polygonArr.push(e.split(":"))
              })
            }
            var polygon = new AMap.Polygon({
              map: self.myMap,
              path: polygonArr,
              strokeColor: res.content.gridColour ? res.content.gridColour : "",
              strokeOpacity: 0.2,
              strokeWeight: 3,
              fillColor: res.content.gridColour ? res.content.gridColour : "",
              fillOpacity: 0.35,
              extData: {
                name: res.content.gridColour ? res.content.orgName : "",
              },
            })
            this.polygon = polygon
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //加载地图
    loadmap(longitude, latitude) {
      //console.log(longitude, latitude, "11")
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("serveMap", {
          resizeEnable: true,
          zoom: 4,
          postion: [longitude, latitude],
          mapStyle: "amap://styles/blue",
        })
        if (
          this.$store.state.orgAreaLevel == 1 ||
          this.$store.state.orgAreaLevel == 2 ||
          this.$store.state.orgAreaLevel == 3
        ) {
          let cities = [this.$store.state.orgAreaName]
          for (let i = 0; i < cities.length; i++) {
            self.areaBG(self.myMap, cities[i])
            // self.myMap.setZoom(8,[longitude, latitude])
            self.myMap.setZoomAndCenter(6, [longitude, latitude])
          }
        } else if (
          this.$store.state.orgAreaLevel == 4 ||
          this.$store.state.orgAreaLevel == 5
        ) {
          //console.log("社区，街道", this.$store.state.orgId)

          if (this.$store.state.orgId != 0) {
            this.$http
              .request({
                url: "/rbac/admin/org/info/findOrgById",
                method: "POST",
                data: {
                  id: this.$store.state.orgId,
                },
              })
              .then((res) => {
                var polygonArr = []
                res.content.pointPosition.split(",").forEach((i) => {
                  //console.log(i)
                  polygonArr.push(i.split(":"))
                })
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                let maxlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlng =
                    maxlng < polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : maxlng
                }
                let minlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlng =
                    minlng > polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : minlng
                }
                let lngs =
                  parseInt(minlng) + (parseInt(maxlng) - parseInt(minlng)) / 2
                let maxlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlat =
                    maxlat < polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : maxlat
                }
                let minlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlat =
                    minlat > polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : minlat
                }
                let lats =
                  parseInt(minlat) + (parseInt(maxlat) - parseInt(minlat)) / 2
                self.myMap.setZoomAndCenter(7, [lngs, lats])
                //self.myMap.setZoomAndCenter(14,[polygonArr[0].lng, polygonArr[0].lat])
                self.polygon.setMap(self.myMap)
              })
          }
        }
        resolve()
      })
    },
    areaBG(map, cityName) {
      //console.log(cityName, "cityName")
      AMap.service("AMap.DistrictSearch", function () {
        let opts = {
          subdistrict: 0,
          extensions: "all",
          level: "district", // 查询行政级别为市
        }
        // 实例化DistrictSearch
        let district = new AMap.DistrictSearch(opts)
        district.setLevel("district")
        // 行政区查询
        district.search(`${cityName}`, function (status, result) {
          // 获取边界信息
          let bounds = result.districtList[0].boundaries
          let polygons = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              // 生成行政区划polygon
              let polygon = new AMap.Polygon({
                map: map,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
              })
              polygons.push(polygon)
              //console.log(polygon)
            }
          }
        })
      })
    },
    // 工单服务
    getWorks(dataIds) {
      const that = this
      request({
        url: "/jjyl/servicePgd/info/findCustomerTypeCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.oldInfo = res.content
          }
        }
      })
    },
    // 获取服务热议经纬度
    getAddress(id) {
      let self = this
      request({
        url: "/jjyl/admin/center/customer/info/findListAll",
        method: "POST",
        data: { customerType: id, pageNo: 1, pageSize: 100 },
      }).then((res) => {
        if (res.code == 200) {
          res.content.list.forEach((item) => {
            if (id == 3) {
              item.icons = require("../../../assets/supervise/clMap.png")
              // item.icons = require("../../../assets/supervise/marker2.png")
            } else if (id == 4) {
              item.icons = require("../../../assets/supervise/lgbMap.png")
              // item.icons = require("../../../assets/supervise/marker2.png")
            } else if (id == 6) {
              item.icons = require("../../../assets/supervise/zfyzMap.png")
              // item.icons = require("../../../assets/supervise/marker2.png")
            } else if (id == 7) {
              item.icons = require("../../../assets/supervise/syMap.png")
              // item.icons = require("../../../assets/supervise/marker2.png")
            } else if (id == 10) {
              item.icons = require("../../../assets/supervise/wmbMap.png")
              // item.icons = require("../../../assets/supervise/marker2.png")
            } else if (id == 13) {
              // item.icons = require("../../../assets/supervise/marker2.png")
              item.icons = require("../../../assets/supervise/tyjrMap.png")
            }
          })
          this.getPoints(res.content.list)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 服务对象
    getServe(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findCusType",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.serveInfo = res.content

            this.serveInfo[0].img = require("../../../assets/supervise/lgbMap.png")
            this.serveInfo[1].img = require("../../../assets/supervise/zfyzMap.png")
            this.serveInfo[2].img = require("../../../assets/supervise/clMap.png")
            this.serveInfo[3].img = require("../../../assets/supervise/wmbMap.png")
            this.serveInfo[4].img = require("../../../assets/supervise/syMap.png")
            console.log(this.serveInfo, "lllll")
            // if (res.content.canlian > 0) {
            //     await this.canlianAddress(3, dataIds)
            // }
            // // if (res.content.junren > 0) {
            // //     await this.junrenAddress(13)
            // // }
            // if (res.content.laogan > 0) {
            //     await this.laoganAddress(4, dataIds)
            // }
            // if (res.content.shangye > 0) {
            //     await this.shangyeAddress(7, dataIds)
            // }
            // if (res.content.wenmingban > 0) {
            //     await this.wenmingbanAddress(10, dataIds)
            // }
            // if (res.content.zhenfuyuanzhu > 0) {
            //     await this.zhengfuyuanzhuAddress(6, dataIds)
            // }
          }
        }
      })
    },
    // 人口区域分布
    peopleArea(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findLifeAreaCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let data = []
            data = [res.content.chengshi, res.content.nongcun]
            this.getpeopleChart(data)
          }
        }
      })
    },
    // 人口分布图表
    getpeopleChart(data) {
      const self = this
      let myChart = this.$echarts.init(document.getElementById("peopleArea"))
      let option
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "20%",
          right: "20%",
          bottom: 20,
          top: "10%",
        },
        xAxis: {
          type: "category",
          data: ["农村", "城市"],
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            symbol: "triangle",
            type: "pictorialBar",
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorlist = ["#2E9EFF", "#FBB828"]
                  return colorlist[params.dataIndex]
                },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 年龄分布
    getAge(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findAgeCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            //console.log(res.content, "年龄数据")
            let data = []
            data[0] = ["50-60岁", res.content.level1]
            data[1] = ["60-70岁", res.content.level2]
            data[2] = ["70-80岁", res.content.level3]
            data[3] = ["80-90岁", res.content.level4]
            data[4] = ["90-100岁", res.content.level5]
            data[5] = ["100岁以上", res.content.level6]
            // //console.log(data, "年龄段")
            this.agesArea(data, "ageArea", "年龄分布")
          }
        }
      })
    },
    // 居住情况
    getHome(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findLiveConditionCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let data = []
            data[0] = ["独子", res.content.duzi]
            data[1] = ["配偶", res.content.peiou]
            data[2] = ["其他", res.content.qita]
            data[3] = ["子女", res.content.zinv]
            // //console.log(data, "年龄段")
            this.agesArea(data, "homeArea", "居住情况")
          }
        }
      })
    },
    // 经济来源
    getSource(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findEconomicSourceCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let data = []
            data[0] = ["兼职", res.content.jianzhi]
            data[1] = ["救济优抚", res.content.jjyf]
            data[2] = ["其他", res.content.qita]
            data[3] = ["养老金", res.content.yanglaojin]
            data[4] = ["子女供养", res.content.zinvgongyang]
            // //console.log(data, "年龄段")
            this.agesArea(data, "moneyArea", "经济来源")
          }
        }
      })
    },
    // 老人自理类型
    getCare(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findSelfCareCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let data = []
            data[0] = ["半失能", res.content.banshineng]
            data[1] = ["不能自理", res.content.bnzl]
            data[2] = ["轻度依赖", res.content.qdyl]
            data[3] = ["失能", res.content.shineng]
            data[4] = ["失智", res.content.shizhi]
            data[5] = ["重度依赖", res.content.zdyl]
            data[6] = ["自理", res.content.zili]
            //console.log(data, "自理类型")
            this.agesArea(data, "oldArea", "老人自理类型")
          }
        }
      })
    },
    // 年龄分布图
    agesArea(data, name, title) {
      var chart = Highcharts.chart(name, {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          backgroundColor: "rgba(255, 255, 255, 0)",
        },
        // colors: ["#2CD1C0", "#FA7093", "#FA7093", "#E8BDF3", "#FBB828"],
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false, //用来设置是否显示‘打印’,'导出'等功能按钮，不设置时默认为显示
        },
        tooltip: {
          title: "",
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
            },
          },
        },
        series: [
          {
            type: "pie",
            name: title,
            data: data,
          },
        ],
      })
    },
    // 人口分析tab
    grapTap(num) {
      this.grapIndex = num
      if (num == 0) {
        this.getAge()
      } else if (num == 1) {
        this.getHome()
      } else if (num == 2) {
        this.getSource()
      } else if (num == 3) {
        this.getCare()
      }
    },

    // 机构点
    getSation(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/serviceStation/info/findStationCustomerCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          // //console.log("机构点", res.content)
          let xData = [],
            yData = []
          if (res.content) {
            res.content.forEach((item) => {
              xData.push(item.stationName)
              yData.push(item.oldManCount)
            })
          }
          this.echartStation(xData, yData)
        }
      })
    },
    // 机构点柱形图
    echartStation(xData, yData) {
      let mayChart = this.$echarts.init(document.getElementById("serveStaion"))
      let option
      option = {
        color: ["#2CD1C0"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "9%",
          top: "3%",
          right: "3%",
          bottom: "30%",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 50,
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 50,
          },
        ],
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: yData,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      }
      option && mayChart.setOption(option)
    },
    // 异常工单
    getAbnormal(dataIds) {
      const that = this
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: -1,
          exceptionType: 1,
          states: 7,
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code === 200) {
          // //console.log("异常工单", res.content.list) latitude: "33.815718587239584" longitude: "117.17211452907986"
          if (res.content) {
            if (res.content.list) {
              this.tableData = res.content.list
            } else {
              this.tableData = []
            }
          } else {
            this.tableData = []
          }
        }
      })
    },
  },
  get methods_3() {
    return this._methods
  },
  set methods_3(value) {
    this._methods = value
  },
  get methods_2() {
    return this._methods
  },
  set methods_2(value) {
    this._methods = value
  },
  get methods_1() {
    return this._methods
  },
  set methods_1(value) {
    this._methods = value
  },
  get methods() {
    return this._methods
  },
  set methods(value) {
    this._methods = value
  },
}
</script>
<style lang="less" scoped>
.homeMain {
  position: relative;
  padding: 0px 12px;
  display: flex;
  max-width: 1920px;
  margin: auto;
  .serveTitle {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding-left: 22px;
    padding-top: 20px;
  }
  .companyImg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .serveBoxes {
    padding: 10px 15px 0px 25px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    z-index: 10;
    height: 67px;
    flex-wrap: wrap;

    .serveItem {
      // flex: 1 1 33.33%;
      padding-top: 30px;
      cursor: pointer;
      display: flex;
      width: 30%;
      .mapPoint {
        width: 36px;
        height: 36px;
      }
    }
    .serveFlex {
      flex: 1;
      margin-left: 15px;
      .name {
        line-height: 24px;
        color: #fff;
        font-size: 14px;
      }
      .nums {
        font-size: 20px;
        padding-top: 5px;
      }
    }
  }
  .homeLeft {
    flex: 1;
    width: 0;
    .homeVersion {
      position: relative;
      width: 100%;
      height: 29vh;
      margin-top: 12px;
      .homeServe {
        padding: 0 40px;
        .serveBox {
          padding: 20px 15px;
          display: flex;
          justify-content: space-between;
          height: 67px;
          .serveItem {
            position: relative;
            width: 151px;
            height: 67px;
            .name {
              width: 80px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              padding-left: 60px;
            }
            .nums {
              font-size: 20px;
              font-weight: bold;
              width: 80px;
              text-align: center;
              line-height: 38px;
              padding-left: 60px;
              color: #fff;
              padding-top: 4px;
            }
            &.serveItem1 {
              margin: 0px 15px;
            }
          }
        }
      }
    }
    .homeMap {
      width: 100%;
      position: relative;
      height: 60vh;
      .trangle {
        width: 34px;
        height: 34px;
        z-index: 1111;
        position: absolute;
        &.trangle1 {
          left: 0px;
          top: 0px;
        }
        &.trangle2 {
          right: -4px;
          bottom: -4px;
          transform: rotate(180deg);
        }
        &.trangle3 {
          left: 0px;
          bottom: -4px;
          transform: rotate(-90deg);
        }
      }
      .trangleRight {
        width: 217px;
        height: 96px;
        position: absolute;
        right: -4px;
        top: 0px;
        z-index: 12;
      }
      .serveMap {
        border: 2px solid #2785dc;
        width: 100%;
        height: 100%;
      }
    }
  }

  .homeCenter {
    width: 27%;
    margin-left: 12px;
    .serveObj {
      width: 100%;
      height: 34vh;
      position: relative;
      .serveTitle1 {
        padding-top: 15%;
      }
      .serveObjTop {
        height: 30vh;
        .serveBox {
          padding: 20px 15px;
          display: flex;
          justify-content: space-between;
          height: 67px;
          .serveItem {
            position: relative;
            width: 151px;
            height: 67px;
            .name {
              width: 80px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              padding-left: 60px;
            }
            .nums {
              font-size: 20px;
              font-weight: bold;
              width: 80px;
              text-align: center;
              line-height: 38px;
              padding-left: 60px;
              color: #fff;
              padding-top: 4px;
            }
            // background: #01b1ff;
            &.serveItem1 {
              margin: 0px 15px;
            }
          }
        }
      }
    }
    .demographic {
      width: 100%;
      position: relative;
      margin-top: 12px;
      height: 55vh;

      .demogTab {
        position: relative;
        z-index: 10;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        span {
          cursor: pointer;
          text-align: center;
          color: #6ebcff;
          font-size: 14px;
          border: 2px solid rgba(46, 158, 255, 0.8);
          line-height: 28px;
          border-radius: 4px;
          margin-right: 8px;
          padding: 0 20px;
          cursor: pointer;
          &.grapCur {
            background: #2889fe;
            color: #fff;
          }
        }
      }
      .demogDes {
        width: 100%;
        height: 20vh;
        position: relative;
        z-index: 20;
        .demogItem {
          width: 100%;
          height: 20vh;
        }
      }
      .peopleName {
        background: #2889fe;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        line-height: 30px;
        width: 140px;
        margin-left: 15px;
        border: 2px solid rgba(46, 158, 255, 0.8);
      }
      .peopleArea {
        width: 100%;
        height: 18vh;
        margin-top: 12px;
        position: relative;
        z-index: 20;
      }
    }
  }
  .homeRight {
    width: 27.5%;
    margin-left: 12px;
    .companyServe {
      width: 100%;
      height: 57vh;
      position: relative;
      .compayTop {
        position: relative;
        z-index: 1000;
        display: flex;
        align-items: center;
        margin-left: 13%;
        .companyName {
          flex: 1;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          padding-left: 20px;
        }
        .companyTab {
          padding: 15px 20px;
          span {
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #6ebcff;
            font-size: 14px;
            margin-right: 12px;
            border: 2px solid rgba(46, 158, 255, 0.8);
            line-height: 28px;
            border-radius: 4px;
            width: 100px;
            &.curIndex {
              background: #2889fe;
              color: #fff;
            }
          }
        }
      }
      .companyHead {
        background: linear-gradient(to right, #01b1ff, #2e9eff);
        margin: 12px 12px 0px;
        display: flex;
        line-height: 40px;
        color: #fff;
        font-size: 15px;
        height: 40px;
        text-align: center;
        .item {
          flex: 1;
        }
        .item2 {
          flex: 2;
        }
      }
      .compayDes {
        height: 38vh;
        overflow: hidden;
        padding: 12px;
        margin-top: 12px;
        position: relative;
        z-index: 2000;
        .desItem {
          display: flex;
          text-align: center;
          align-items: center;
          font-size: 14px;
          line-height: 24px;
          cursor: pointer;
          color: #01b1ff;
          .item {
            flex: 1;
          }
          .item2 {
            flex: 2;
          }
        }
      }
    }
    .serveStation {
      margin-top: 12px;
      position: relative;
      width: 100%;
      height: 32vh;
      #serveStaion {
        width: 100%;
        position: relative;
        z-index: 20;
        margin-top: 10px;
        height: 26vh;
      }
    }
  }
}
.lgbColor {
  color: #fefe00 !important;
}
.zfyzColor {
  color: #2ccfc0 !important;
}
.clColor {
  color: #fa7093 !important;
}
.wmbColor {
  color: #e8bdf3 !important;
}
.tyjrColor {
  color: #975fe4 !important;
}
.syColor {
  color: #fbb828 !important;
}

// 地图
.circleBtn {
  position: absolute;
  left: 30px;
  top: 20px;
  z-index: 2000;
}

/deep/.amap-info-content {
  // width: 200px;
  // height: 250px;
  padding: 0;
  background: rgba(0, 30, 65, 0.8);
  z-index: 2000;
  .mapTitle {
    height: 40px;
    color: #fff;
    background: rgba(0, 60, 125, 1);
    padding: 0 15px;
    line-height: 40px;
    font-size: 16px;
    display: flex;
    span {
      flex: 1;
    }
    .icon {
      font-size: 16px;
      line-height: 40px;
      cursor: pointer;
    }
  }
  .mapUl {
    padding: 15px;
    .mapLi {
      display: flex;
      line-height: 30px;
      line-height: 30px;
      font-size: 30px;
      font-size: 14px;
      color: #fff;
      .name {
        width: 110px;
        text-align: right;
      }
      .content {
        flex: 1;
        margin-right: 10px;
      }
    }
  }
}
/deep/.bottom-center {
  .amap-info-sharp {
    bottom: 0;
    left: 50%;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgba(0, 30, 65, 0.8);
  }
}
/deep/.amap-info-close {
  top: 12px;
}

.maskModel {
  // width: 650px;
  height: 700px;
  background: rgba(2, 29, 54, 1);
  border: 1px solid rgba(110, 188, 255, 1);
  position: absolute; /*参照物是父容器*/
  left: 50%;
  top: 2%;
  transform: translateX(-50%); /*百分比的参照物是自身*/
  z-index: 2000;
  .yearMoney {
    display: flex;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    padding: 0px 12px;
    background: rgba(0, 60, 125, 1);
    .name {
      color: #fff;
      font-size: 16px;
      flex: 1;
    }
    .maskClose {
      width: 19px;
      height: 19px;
      position: relative;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
  }
}
.personFlex {
  // display: flex;
  align-items: center;
  padding: 30px 15px;
  /deep/.el-input__inner {
    background: none;
    color: #fff;
    border: none;
  }
  /deep/.el-radio__inner,
  /deep/.el-checkbox__inner,
  /deep/.el-textarea__inner {
    background: none;
  }
  /deep/.el-textarea__inner {
    color: #fff;
  }
  .img {
    width: 150px;
    height: 150px;
    margin-right: 15px;
    margin-top: 5px;
  }
  .personConent {
    flex: 1;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 30px;
  }
}
.maskTab {
  background: linear-gradient(to right, #01b1ff, #2e9eff);
  margin: 12px 12px 0px;
  display: flex;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  height: 40px;
  text-align: center;
  .item {
    flex: 1;
  }
  .item2 {
    flex: 2;
  }
}
.maskDes {
  margin: 12px 12px 16px;
  // display: flex;
  height: 28vh;
  position: relative;
  z-index: 20;
  overflow: hidden;
  line-height: 0px;
  .desItem {
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 14px;
    line-height: 25px;
    cursor: pointer;
    color: #01b1ff;
    .item {
      flex: 1;
      .centerTip,
      .centerTip1 {
        width: 100px;
        display: inline-block;
        padding: 0 10%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .centerTip1 {
        width: 80px;
      }
    }
    .item2 {
      flex: 2;
    }
  }
}
.maksPage {
  margin: 0 12px;
  /deep/.el-pagination__total,
  /deep/.el-pagination__jump {
    color: #fff;
  }
}
.charmap {
  width: 100%;
  height: 50vh;
  z-index: 3000;
  position: relative;
}

.right-1 {
  width: 98%;
  margin-left: 2%;
  display: flex;
}

.right-1 > div {
  width: 33.33%;
}

.right-title-1 {
  width: 100%;
  display: flex;
  color: #fff;
  height: 40px;
  font-size: 14px;
  align-items: center;
  border-bottom: 1px solid #fff;
  .overs {
    /deep/.el-select__tags {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap !important;
    }
  }
}

.right-title-2 {
  border-top: 1px solid #fff;
}

.right-title-3 {
  border-right: 1px solid #fff;
  color: #fff;
}

.right-title-1 > div:first-child {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-1 > div:nth-child(2) {
  height: 40px;
  line-height: 40px;
  width: calc(100% - 100px);

  /deep/ .el-input__inner {
    border: none;
  }
}

.right-2 {
  width: 100%;
  display: flex;
  margin: 20px 0 34px 0;
  justify-content: center;
}

.shangchuang {
  width: 178px;

  margin-top: 20px;
  text-align: center;
}
.shangchuang2 {
  display: flex;
  margin-top: 20px;
  text-align: center;
  .item {
    flex: 1;
    height: 30px;
    cursor: pointer;
    line-height: 30px;
    border-radius: 5px;
    color: #ffffff;
    background-color: #0000ff;
    &.item1 {
      margin-left: 12px;
    }
  }
}

.bottom-1 {
  width: 98%;
  margin-left: 2%;
}

.bottom-1 > div:first-child {
  width: 100%;
}

.right-title-5 {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid #fff;
}

.right-title-5 > div:first-child {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-4 {
  width: calc(100% - 100px);
  display: flex;
  align-items: center;
}

.right-title-4 > div:first-child {
  margin-left: 20px;
}

.map_container {
  margin-top: 12px;
  display: flex;

  .map_left {
    box-sizing: border-box;
    margin-right: 10px;
    width: 260px;
    height: 300px;
    padding: 12px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;

    p {
      line-height: 42px;
      text-align: center;
    }
  }

  .map_right {
    width: 100%;
    height: 300px;
  }
}

.right-title-4 > div:nth-child(2) {
  margin-left: 10px;
  width: 200px;
}

.right-title-6 {
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
  border-bottom: 1px solid #fff;
}

.right-title-6 > div:first-child {
  width: 100px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-7 {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  // justify-content: space-between;
  border-bottom: 1px solid #fff;
}

.right-title-7 > div:first-child {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-7 > div:nth-child(2) {
  width: calc(100% - 140px);

  /deep/ .el-input__inner {
    border: none;
  }
}

.colorIcon {
  color: #0000ff;
  font-size: 30px;
}

.right-title-8 {
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
  border-bottom: 1px solid #fff;
}

.right-title-8 > div:first-child {
  width: 100px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-8 > div:nth-child(2) {
  width: calc(100% - 100px);

  /deep/ .el-textarea__inner {
    border: none;
    resize: none;
  }
}

.list-1 {
  width: 100%;
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
}

.list-2 {
  width: 150px;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}

.change {
  background-color: #0000ff;
}

.right-title-9 {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
}

.right-title-9 > div:first-child {
  width: 100px;
  padding: 20px 0;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  text-align: center;
}

.right-title-9 > div:nth-child(2) {
  margin-left: 20px;
}

.tap2-1 {
  width: 100%;
  display: flex;
}

.tap2-1 > div:first-child {
  width: 65%;
  margin: 20px 0;
  margin-right: 5%;
}

.tap2-1 > div:nth-child(2) {
  width: 30%;
}

.tap2-2 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.tap2-3 {
  width: 48%;
  display: flex;
  align-items: center;
}

.tap2-3 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap2-3 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.tap2-4 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.tap2-4 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap2-4 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.shangchuang1 {
  width: 128px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  color: #ffffff;
  margin-top: 15px;
  text-align: center;
  background-color: #0000ff;
}

.tap4-2 {
  font-size: 12px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar1 {
  width: 128px;
  height: 128px;
  display: block;
}
</style>
